module.exports = __webpack_public_path__ + "static/media/logo-cardillo.0be6341f.png";